import React, { useEffect, useState } from 'react';
export const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState(20 * 60); // 20 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <span className="font-mono font-bold tracking-wider bg-white/20 px-2 py-1 rounded-md ml-2 inline-block" data-id="element-166" data-mp="3c1ctyzmeamul">
      {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
    </span>;
};